import * as React from 'react';

import {OnboardingModal} from 'shells/onboarding-modal/onboarding-modal';

import type {CalendarSync} from 'nutshell-graphql-types';

import {art} from './consts';
import {Introduction, Connect, Connected, Ready} from './pages';

type Props = {
    calendarSync: CalendarSync | null | undefined;
    isLoading: boolean;
    refetchSyncStatus: () => Promise<any>;
    onClose: () => void;
    onSuccess?: () => any;
};

export function CalendarOnboardingModal(props: Props) {
    const [pageAutoAdvance, setPageAutoAdvance] = React.useState(false);

    const pages = [
        {
            id: 'Introduction',
            body: <Introduction />,
            art,
        },
        {
            id: 'Connect',
            body: (
                <Connect
                    calendarSync={props.calendarSync}
                    setPageAutoAdvance={setPageAutoAdvance}
                    refetchSyncStatus={props.refetchSyncStatus}
                    onSuccess={props.onSuccess}
                />
            ),
            art,
            nextDisabled: !props.calendarSync,
        },
        {
            id: 'Connected',
            body: (
                <Connected
                    calendarSync={props.calendarSync}
                    isLoading={props.isLoading}
                    refetchSyncStatus={props.refetchSyncStatus}
                    oneStepDisconnect={false}
                    canDisconnect={true}
                />
            ),
            art,
            nextDisabled: props.calendarSync && !props.calendarSync.isEnabled,
        },
        {
            id: 'Ready',
            body: <Ready />,
            art,
        },
    ];

    return (
        <OnboardingModal
            trapFocus={false}
            lastButtonText='Done'
            // @ts-expect-error
            pages={pages}
            onClose={props.onClose}
            onFinish={props.onClose}
            pageAutoAdvance={pageAutoAdvance}
            maxHeight={600}
            closeButton={false}
        />
    );
}
